export default {
  methods: {
    /**
     * Formats an array of strings into a comma-separated list with "and" before the last item.
     * Examples:
     *   [] -> ""
     *   ["1"] -> "1"
     *   ["1", "2"] -> "1 and 2"
     *   ["1", "2", "3"] -> "1, 2, and 3"
     *   ["1", "2", "3", "4"] -> "1, 2, 3, and 4"
     *
     * @param {Array<string>} items - Array of strings to format
     * @returns {string} Formatted string with commas and "and" before the last item
     */
    formatList(items) {
      if (!items || items.length === 0) {
        return "";
      }

      if (items.length === 1) {
        return items[0];
      }

      if (items.length === 2) {
        return `${items[0]} and ${items[1]}`;
      }

      // For 3+ items: "1, 2, 3, and 4"
      const allButLast = items.slice(0, -1).join(", ");
      const last = items[items.length - 1];
      return `${allButLast}, and ${last}`;
    },
  },
};
